// src/utils/validation.ts

export function validatePhone(number: string): boolean {
  const trimmed = number.trim();
  return /^[0-9]{8,14}$/.test(trimmed);
}

export function containsInvalidChar(number: string): boolean {
  return /[^0-9]/.test(number);
}

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
